const ar = {
  common: {
    notSpecified: 'غير محدد',
    urgent: 'عاجل',
    normal: 'عادي',
    name: 'الاسم',
    patientName: 'اسم المريض',
    service: 'الخدمة',
    age: 'العمر',
    gender: 'الجنس',
    male: 'ذكر',
    female: 'أنثى',
    services: {
      standard: 'موعد مع طبيب',
      secondOpinion: 'رأي طبي ثانٍ',
      homecare: 'رعاية منزلية',
    },
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    save: 'حفظ',
    submit: 'إرسال',
    loading: 'جاري التحميل...',
    searchPlaceholder: 'بحث...',
    select: 'اختر',
    all: 'الكل',
    previous: 'السابق',
    next: 'التالي',
    close: 'إغلاق',
    back: 'رجوع',
    delete: 'حذف',
    edit: 'تعديل',
    yes: 'نعم',
    no: 'لا',
    listSeparator: '، ',
  },
  home: {
    searchSpecialties: 'البحث في التخصصات...',
    quickOptions: 'خيارات سريعة',
    specialties: 'التخصصات',
    searchResults: 'نتائج البحث',
    searchResultsFor: '{{value}} نتيجة بحث عن "{{query}}"',
    viewAll: 'عرض الكل',
    noSpecialties: 'لا توجد تخصصات',
    noSpecialtiesDescription: 'لا توجد تخصصات متاحة حالياً',
    noSpecialtiesMatching: 'لم يتم العثور على تخصصات تحتوي على "{{query}}"',
    consultationQuotaReached:
      'تم استنفاد رصيد الاستشارات. يرجى التواصل مع فريق المبيعات.',
    printingQuotaReached:
      'تم استنفاد رصيد الطباعة ثلاثية الأبعاد. يرجى التواصل مع فريق المبيعات.',
    sections: {
      upcomingAppointments: 'المواعيد القادمة',
      noUpcomingAppointments: 'لا توجد مواعيد قادمة',
      secondOpinionRequests: 'طلبات الرأي الثاني',
      noSecondOpinionRequests: 'لا توجد طلبات رأي ثاني',
      homecareReservations: 'حجوزات الرعاية المنزلية',
      noHomecareReservations: 'لا توجد حجوزات رعاية منزلية',
      printingRequests: 'طلبات الطباعة ثلاثية الأبعاد',
      noPrintingRequests: 'لا توجد طلبات طباعة بعد',
    },
    options: {
      bookAppointment: {
        title: 'احجز موعد مع طبيب',
        subtitle: 'احجز موعدك للحصول على استشارة طبية',
        description:
          'احجز موعدك مع أفضل الأطباء في مختلف التخصصات خلال دقائق. استشارات طبية موثوقة عبر الفيديو أو الدردشة النصية، متى احتجت إليها ومن أي مكان.',
      },
      secondOpinion: {
        title: 'احصل على رأي طبي ثانٍ',
        subtitle: 'تأكد من تشخيصك مع أطباء متخصصين',
        description:
          'لا تدع الشك يؤثر على قراراتك الصحية. احجز موعدًا مع أطباء ذوي خبرة للحصول على رأي طبي ثانٍ موثوق يساعدك على اتخاذ القرار الصحيح بشأن علاجك.',
      },
      homecare: {
        title: 'خدمات الرعاية المنزلية',
        subtitle: 'احجز خدمة رعاية منزلية',
        description:
          'احصل على خدمات طبية في منزلك من مقدمي خدمات معتمدين. تمريض، علاج طبيعي، وخدمات صحية متنوعة تصل إليك أينما كنت.',
      },
      printing: {
        title: 'الطباعة ثلاثية الأبعاد',
        subtitle: 'اطلب نموذجًا طبيًا مطبوعًا ثلاثي الأبعاد',
        description:
          'أرسل ملف الفحص (zip) وسيقوم فريقنا المتخصص بإنتاج نموذج تشريحي أو دليل جراحي أو طرف اصطناعي بالتعاون مع مستشفانا الشريك.',
      },
    },
    dialog: {
      bookAppointment: 'حجز موعد مع طبيب',
      secondOpinion: 'احصل على رأي طبي ثان',
    },
  },
  cards: {
    appointment: {
      prefix: 'موعد',
      date: 'تاريخ الموعد',
      time: 'وقت الموعد',
      patientName: 'اسم المريض',
      doctorName: 'اسم الطبيب',
    },
    secondOpinion: {
      prefix: 'رأي ثاني',
      specialty: 'التخصص',
      deliveryTime: 'وقت التسليم',
      priority: 'الأولوية',
      doctorName: 'اسم الطبيب',
    },
    homecareReservation: {
      prefix: 'رعاية منزلية',
      service: 'الخدمة',
      provider: 'مقدم الخدمة',
      date: 'تاريخ الموعد',
      time: 'وقت الموعد',
    },
  },
  profile: {
    age: 'العمر',
    entity: 'الجهة',
  },
  pricing: {
    servicePrice: 'سعر الخدمة',
    totalAmount: 'المبلغ الكلي',
    insuranceDiscount: 'خصم التأمين',
    vat: 'ضريبة القيمة المضافة',
    amountDue: 'المبلغ المطلوب',
    paymentDetailsTitle: 'تفاصيل الدفع',
    promoDiscount: 'خصم كود الخصم',
  },
  promoCode: {
    label: 'كود الخصم',
    placeholder: 'أدخل كود الخصم',
    apply: 'تطبيق',
    applying: 'جاري التطبيق...',
    remove: 'إزالة',
    appliedSummary: 'تم تطبيق كود الخصم {{code}} ({{percent}}%)',
    havePromo: 'لديك كود خصم؟',
    errors: {
      notFound: 'كود الخصم غير صحيح',
      expired: 'انتهت صلاحية كود الخصم',
      notYetActive: 'كود الخصم غير مفعّل بعد',
      limitReached: 'تم الوصول إلى الحد الأقصى لاستخدام كود الخصم',
      generic: 'تعذّر تطبيق كود الخصم',
    },
  },
  status: {
    waitingConfirmation: 'انتظار التأكيد',
    waitingDoctorAssignment: 'انتظار تخصيص الطبيب',
    waitingDoctorConfirmation: 'انتظار تأكيد الطبيب',
    finished: 'مكتمل',
    confirmed: 'مؤكد',
    canceled: 'ملغي',
    availableForFollowup: 'متاحة للمتابعة',
    expired: 'منتهي الصلاحية',
    unknown: 'حالة غير معروفة',
  },
  symptomForm: {
    subtitle: 'سيطّلع الطبيب على هذه المعلومات عند استلام طلب الموعد',
    attachmentHint:
      'مثل: نتائج التحاليل، الوصفات الطبية السابقة، صور توضيحية للحالة إن أمكن',
    privacyNote: 'معلوماتك الطبية سرية ومحمية',
    hints: {
      suffering: 'من ماذا تعاني؟',
      chronic: 'هل لديك أي أمراض مزمنة؟',
      onset: 'متى بدأت الأعراض؟',
    },
  },
  booking: {
    appointmentTitle: 'حجز موعد مع طبيب',
    secondOpinionTitle: 'احصل على رأي طبي ثانٍ',
    homecareTitle: 'خدمات الرعاية المنزلية',
    specialtySelection: {
      title: 'اختيار التخصص',
      subtitle: 'الرجاء اختيار التخصص المطلوب',
      searchPlaceholder: 'البحث',
      noResults: 'لا توجد نتائج بحث',
      back: 'رجوع',
      continue: 'متابعة',
    },
    symptomChecker: {
      title: 'وصف الأعراض',
      subtitleSelf: 'الرجاء تعبئة البيانات وإرفاق الملفات إن وُجدت',
      subtitleB2B: 'الرجاء تعبئة بيانات المريض وإرفاق الملفات إن وُجدت',
      bookingForSelf: 'لنفسي',
      bookingForOther: 'لشخص آخر',
      fields: {
        name: 'الاسم',
        age: 'العمر',
        gender: 'الجنس',
        symptoms: 'وصف الأعراض',
        symptomsPlaceholder:
          'أعاني من ارتفاع في درجة الحرارة و ألم في الحلق ...',
        patientName: 'اسم المريض',
        patientNamePlaceholder: 'أدخل اسم المريض',
        doctorName: 'اسم الطبيب المحوِّل',
        doctorNamePlaceholder: 'أدخل اسم الطبيب المحوِّل',
        guestEmail: 'بريد حضور الاجتماع',
        guestEmailPlaceholder: 'doctor@hospital.com',
        guestEmailHint: 'سيتم إرسال رابط الاجتماع إلى هذا البريد تلقائياً',
        ageSuffix: 'عام',
      },
      validation: {
        symptomsMin: 'يرجى وصف الأعراض بالتفصيل (على الأقل 10 أحرف)',
        patientName: 'يرجى إدخال اسم المريض',
        patientBirthDate: 'يرجى إدخال تاريخ الميلاد',
        patientGender: 'يرجى اختيار الجنس',
        doctorName: 'يرجى إدخال اسم الطبيب المحوِّل',
        guestEmail: 'يرجى إدخال بريد حضور الاجتماع',
        guestEmailInvalid: 'يرجى إدخال بريد إلكتروني صحيح',
      },
      submitting: 'جاري الإرسال...',
      back: 'رجوع',
      continue: 'التالي: اختيار الطبيب',
    },
    appointmentTime: {
      title: 'حجز موعد',
      subtitle: 'الرجاء قم باختيار الموعد المناسب',
      back: 'رجوع',
      continue: 'متابعة',
      pickDate: 'اختر تاريخ',
      noSlots: 'لا توجد أوقات متاحة في هذا اليوم',
    },
    bookingConfirmation: {
      title: 'تأكيد الحجز',
      subtitle: 'الرجاء تأكيد الحجز',
      detailsHeader: 'تفاصيل الحجز',
      appointmentPill: 'الموعد',
      back: 'رجوع',
      confirm: 'تأكيد الحجز',
      payAndConfirm: 'المتابعة للدفع',
      processing: 'جاري المعالجة...',
      servicePrice: 'سعر الخدمة',
      amountDue: 'المبلغ المطلوب',
      missingReservation: 'تعذر إيجاد تفاصيل الحجز. يرجى المحاولة مرة أخرى.',
      paymentFailed: 'تعذر إتمام الدفع، يرجى المحاولة مرة أخرى.',
      missingDoctorName: 'يرجى إدخال اسم الطبيب المحوِّل',
      missingGuestEmail: 'يرجى إدخال بريد حضور الاجتماع',
      remainingQuota: 'الرصيد المتبقي',
      consultationsLeft: 'الاستشارات المتبقية: {{remaining}}',
      topUpHint: 'يرجى التواصل مع المسؤول لتجديد الرصيد.',
      submittedWithRemaining:
        'تم تأكيد الحجز. الاستشارات المتبقية: {{remaining}}.',
    },
    requestStatus: {
      paymentFailed: 'فشل في الدفع',
      paymentFailedDescription:
        'لم يتم إتمام عملية الدفع. يرجى المحاولة مرة أخرى أو التواصل مع الدعم.',
      underReview: 'الطلب قيد المراجعة',
      underReviewDescription:
        'الطلب قيد المراجعة، وسيتم اعلامك بالايميل / رسالة نصية عند اتمام الطلب و تأكيد الموعد.',
      underReviewHomecareDescription:
        'طلب الرعاية المنزلية قيد المراجعة، وسيتم اعلامك بالايميل / رسالة نصية عند اتمام الطلب و تأكيد الموعد.',
      retry: 'إعادة المحاولة',
      home: 'الصفحة الرئيسية',
      backHome: 'العودة إلى الرئيسية',
      viewAppointments: 'عرض المواعيد',
    },
    paymentDescription: 'حجز موعد مع طبيب',
  },
  secondOpinion: {
    title: 'رأي طبي ثانٍ',
    pageTitle: 'رأي طبي ثاني',
    notFound: 'لم يتم العثور على الطلب.',
    urgent: 'عاجل',
    normal: 'عادي',
    priority: 'الأولوية',
    urgentDescription: 'سيتم الرد على طلبك خلال 24 ساعة. تكلفة إضافية.',
    normalDescription: 'سيتم الرد على طلبك خلال 72 ساعة.',
    selectPriority: 'اختر الأولوية',
    submitRequest: 'إرسال الطلب',
    urgentRequest: 'طلب عاجل',
    normalRequest: 'طلب عادي',
    card: {
      titleWithSpecialty: 'رأي ثاني - {{specialty}}',
      requestNumber: 'رقم الطلب:',
      priority: 'الأولوية:',
      dueDate: 'الاستحقاق:',
      serviceType: 'نوع الخدمة:',
      caseDoctor: 'طبيب الحالة:',
      statusLabel: 'الحالة:',
      priceLabel: 'السعر:',
      paid: 'مدفوع',
      attachmentsHeader: 'البيانات المرفقة',
      viewAttachments: 'عرض البيانات المرفقة',
    },
    statuses: {
      waitingDoctorAssignment:
        'قيد المراجعة وسيتم اعلامك في حال التأكيد. {{urgency}}',
      waitingDoctorConfirmation:
        'تم إرسال طلبك للطبيب، وبانتظار التأكيد. {{urgency}}',
      confirmed: 'تم تأكيد الطلب بنجاح. الاستحقاق: {{date}}',
      finished: 'تم الانتهاء من الرأي الثاني.',
    },
    timeline: {
      referred: {
        title: 'تم تحويل الحالة إلى طبيب آخر',
        message: 'تم تحويل طلب الرأي الثاني إلى طبيب مختص آخر لمراجعة الحالة.',
      },
      created: {
        title: 'تم إنشاء طلب رأي ثاني #{{number}}',
        message:
          'تم إنشاء طلب جديد بنجاح. سيتم مراجعة طلبك وتعيين طبيب مختص في أقرب وقت ممكن.',
      },
      finished: {
        title: 'تم الانتهاء من الرأي الثاني',
        message: 'تم الانتهاء من مراجعة الحالة وإرفاق التقرير.',
      },
      doctorAssigned: {
        title: 'تم تحديد طبيب للحالة',
        message: 'تم تعيين الدكتور {{name}} لمراجعة حالتك.',
      },
      doctorConfirmed: {
        title: 'تم تأكيد الطلب من الطبيب',
        message: 'قام الطبيب بتأكيد استلام الطلب وسيبدأ بمراجعة الحالة.',
      },
      moreInfoNeeded: {
        title: 'مطلوب مزيد من المعلومات',
        message:
          'يطلب الطبيب مزيدًا من المعلومات لمراجعة حالتك بشكل أفضل. يرجى تقديم المعلومات المطلوبة.',
      },
      infoSubmitted: {
        title: 'تم إرسال معلومات إضافية',
        message:
          'تم إرسال المعلومات الإضافية بنجاح. جاري المراجعة من قبل الطبيب.',
      },
    },
    symptomChecker: {
      title: 'ارفاق معلومات اضافية',
      subtitleSelf: 'الرجاء تعبئة البيانات وإرفاق الملفات إن وُجدت',
      subtitleB2B: 'الرجاء تعبئة بيانات المريض وإرفاق الملفات إن وُجدت',
      urgentCheckbox: 'الطلب مستعجل',
      continue: 'التالي: تأكيد الطلب',
      priceSummaryNormal:
        'سعر الخدمة العادي: <strong>260 ريال</strong>، المدة المتوقعة للرد: <strong>10 أيام</strong>',
      priceSummaryUrgent:
        'للطلب المستعجل سيتم إضافة: <strong>200 ريال</strong>، المدة المتوقعة للرد: <strong>2 أيام</strong>',
    },
    submitInfo: {
      trigger: 'تقديم المعلومات الإضافية',
      title: 'تقديم المعلومات الإضافية',
      doctorRequestedPrefix: 'المعلومات المطلوبة من الطبيب:',
      details: 'التفاصيل',
      detailsPlaceholder: 'يرجى كتابة المعلومات الإضافية المطلوبة هنا...',
      submit: 'إرسال',
      submitting: 'جاري الإرسال...',
      validation: 'يرجى إدخال التفاصيل أو إرفاق ملف واحد على الأقل',
    },
    confirmation: {
      title: 'تأكيد الحجز',
      subtitle: 'الرجاء تأكيد الحجز',
      detailsHeader: 'تفاصيل الحجز',
      urgentLabel: 'الطلب مستعجل',
      notUrgentLabel: 'الطلب غير مستعجل',
      urgentWithFee: 'الطلب مستعجل: +{{fee}} المدة المتوقعة للرد يومين.',
      notUrgentDescription: 'الطلب غير مستعجل: المدة المتوقعة للرد ١٣ يوم.',
      confirm: 'تأكيد الحجز',
      payAndConfirm: 'المتابعة للدفع',
      processing: 'جاري المعالجة...',
      back: 'رجوع',
      missingDoctorName: 'يرجى إدخال اسم الطبيب المحوِّل',
    },
  },
  homecare: {
    pageTitle: 'خدمات الرعاية المنزلية',
    vendors: 'مقدمو الخدمات',
    services: 'الخدمات',
    reservationDetails: 'تفاصيل الحجز',
    selectDate: 'اختر التاريخ',
    selectTime: 'اختر الوقت',
    selectService: 'اختر الخدمة',
    selectedVendor: 'مقدم الخدمة المختار',
    continue: 'المتابعة',
    back: 'رجوع',
    requiredAmount: 'المبلغ المطلوب',
    provider: 'مقدم الخدمة',
    appointment: 'الموعد',
    noVendors: 'لا يوجد مقدمو خدمات متاحون',
    noServices: 'لا توجد خدمات متاحة',
    confirmation: {
      title: 'تأكيد الحجز',
      subtitle: 'الرجاء تأكيد الحجز',
      detailsHeader: 'تفاصيل الحجز',
      paymentDetailsHeader: 'تفاصيل الدفع',
      confirm: 'تأكيد الحجز',
      payAndConfirm: 'المتابعة للدفع',
      processing: 'جاري المعالجة...',
    },
    bookService: {
      title: 'احجز موعدك',
      subtitle: 'اختر الخدمة والموعد المناسب',
      needsSubtitle:
        'سيطّلع مزود الخدمة على هذه المعلومات عند استلام طلب الموعد',
      describeNeeds: 'وصف احتياجاتك',
      symptomsPlaceholder:
        'أحتاج إلى خدمة تمريض منزلي لمتابعة ضغط الدم والسكر...',
      hints: {
        service: 'ما الخدمة التي تحتاجها؟',
        chronic: 'هل لديك أي أمراض مزمنة؟',
        duration: 'منذ متى تحتاج إلى الرعاية؟',
      },
      selectAppointment: 'اختر الموعد',
      total: 'المجموع',
      booking: 'جاري الحجز...',
      vendorNotFound: 'مقدم الخدمة غير موجود',
      validation: {
        serviceRequired: 'يرجى اختيار الخدمة',
        symptomsMin: 'يرجى وصف احتياجاتك بالتفصيل (على الأقل 10 أحرف)',
        slotRequired: 'يرجى اختيار موعد',
        patientInfoRequired:
          'يرجى إدخال بيانات المريض (الاسم، تاريخ الميلاد، الجنس)',
      },
    },
    serviceListing: {
      searchPlaceholder: 'ابحث عن خدمة أو مقدم خدمة...',
      vendorTypeIndividual: 'مقدم خدمة',
      vendorTypeClinic: 'عيادة',
      cityPlaceholder: 'المدينة',
      allCities: 'كل المدن',
      dayPlaceholder: 'اليوم',
      allDays: 'كل الأيام',
      noResultsTitle: 'لا توجد نتائج',
      noResultsForQuery: 'لم يتم العثور على نتائج تحتوي على "{{query}}"',
      noResultsWithFilters: 'لا توجد خدمات متاحة بالفلاتر المحددة',
      clearFilters: 'إزالة الفلاتر',
      bookNow: 'احجز الآن',
      yearsExperience: '{{value}} سنوات خبرة',
      availableLabel: 'متاح:',
      availableDaily: 'متاح يومياً',
      priceFrom: 'من',
      priceCurrency: 'ر.س',
      weekdays: {
        SUNDAY: 'الأحد',
        MONDAY: 'الاثنين',
        TUESDAY: 'الثلاثاء',
        WEDNESDAY: 'الأربعاء',
        THURSDAY: 'الخميس',
        FRIDAY: 'الجمعة',
        SATURDAY: 'السبت',
      },
    },
    reservationDetail: {
      headerTitle: 'رعاية منزلية #{{counter}}',
      backAria: 'رجوع',
      notFound: 'لم يتم العثور على الحجز',
      sectionTitle: 'تفاصيل الحجز',
      service: 'الخدمة',
      date: 'التاريخ',
      time: 'الوقت',
      price: 'السعر',
      descriptionLabel: 'وصف الحالة',
      cancelButton: 'إلغاء الحجز',
      attachmentsTitle: 'المرفقات',
      timelineTitle: 'سجل الحالة',
      providerTitle: 'مقدم الخدمة',
      providerBio: 'نبذة',
      vendorTypeIndividual: 'فرد',
      vendorTypeClinic: 'مؤسسة',
      patientTitle: 'معلومات المريض',
      patientName: 'الاسم',
      patientPhone: 'الهاتف',
      patientEmail: 'البريد',
      cancelDialog: {
        title: 'تأكيد إلغاء الحجز',
        description:
          'هل أنت متأكد من رغبتك في إلغاء حجز الرعاية المنزلية #{{counter}}؟ لا يمكن التراجع عن هذا الإجراء.',
        cancel: 'إلغاء',
        confirm: 'تأكيد الإلغاء',
      },
      timeline: {
        CREATED: 'تم إنشاء الحجز',
        CONFIRMED: 'تم تأكيد الحجز',
        FINISHED: 'تم إنهاء الخدمة',
        CANCELED: 'تم إلغاء الحجز',
      },
      statuses: {
        WAITING_CONFIRMATION: 'بانتظار تأكيد مقدم الخدمة',
        CONFIRMED: 'تم تأكيد الموعد',
        FINISHED: 'تم إنهاء الخدمة',
        CANCELED: 'تم إلغاء الحجز',
      },
      cancelErrors: {
        missingDate: 'لا يمكن العثور على تاريخ الموعد.',
        tooLate: 'لا يمكن إلغاء الموعد قبل أقل من {{hours}} ساعات.',
      },
      cancelSuccess: 'تم إلغاء الحجز بنجاح',
      cancelError: 'تعذر إلغاء الحجز. يرجى تحديث الصفحة والمحاولة مرة أخرى.',
      finishButton: 'إنهاء الخدمة',
      finishNotStartedYet: 'يمكنك إنهاء الخدمة بعد وقت بداية الموعد',
      finishSuccess: 'تم إنهاء الخدمة بنجاح',
      finishError: 'تعذر إنهاء الخدمة. يرجى تحديث الصفحة والمحاولة مرة أخرى.',
      finishDialog: {
        title: 'تأكيد إنهاء الخدمة',
        description:
          'هل تمت زيارة الرعاية المنزلية #{{counter}}؟ سيتم تعليم الحجز كمكتمل.',
        cancel: 'رجوع',
        confirm: 'نعم، إنهاء الخدمة',
      },
    },
    paymentDescription: 'حجز خدمة رعاية منزلية - {{service}}',
  },
  specialties: {
    pageTitle: 'جميع التخصصات',
    searchPlaceholder: 'البحث في التخصصات...',
    searchResultsFor: '{{value}} نتيجة بحث عن "{{query}}"',
    empty: 'لا توجد تخصصات',
    emptyDescription: 'لا توجد تخصصات متاحة حالياً',
    emptySearch: 'لم يتم العثور على تخصصات تحتوي على "{{query}}"',
  },
  profilePage: {
    pageTitle: 'الملف الشخصي',
    personalInfo: 'المعلومات الشخصية',
    accountInfo: 'معلومات الحساب',
    logout: 'تسجيل الخروج',
    editInfo: 'تعديل المعلومات',
    save: 'حفظ التغييرات',
    cancel: 'إلغاء',
    saving: 'جاري الحفظ...',
    firstName: 'الاسم الأول',
    parentName: 'اسم الأب (اختياري)',
    lastName: 'الاسم الأخير',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    phoneNumber: 'رقم الهاتف',
    birthDate: 'تاريخ الميلاد',
    gender: 'الجنس',
    ageLabel: 'العمر: {{value}}',
    residency: 'مكان الإقامة (اختياري)',
    residencyLabel: 'مكان الإقامة: {{value}}',
    genderLabel: 'الجنس: {{value}}',
    nationalId: 'الرقم الوطني / الإقامة',
    nationalIdWithInsurance: 'الرقم الوطني / الإقامة (لربط التأمين)',
    insuranceCompany: 'شركة التأمين',
    accountType: 'نوع الحساب',
    organizationAccount: 'حساب مؤسسة',
    organizationName: 'اسم المؤسسة',
    createdAt: 'تاريخ الإنشاء',
    phoneNumberLine: 'رقم الهاتف: {{value}}',
    emailLine: 'البريد الإلكتروني: {{value}}',
    updateSuccess: 'تم تحديث الملف الشخصي بنجاح',
    termsLink: 'شروط الخدمة والخصوصية',
    termsDescription: 'راجع شروط الاستخدام وسياسة الخصوصية',
    contactUsWhatsapp: 'تواصل عبر واتساب',
    contactUsWhatsappDescription: 'للمحادثة المباشرة مع الدعم',
  },
  notifications: {
    pageTitle: 'الإشعارات',
    markAllRead: 'تحديد الكل كمقروء',
    noNotifications: 'لا توجد إشعارات',
    noNotificationsDescription: 'لم يتم العثور على أي إشعارات في الوقت الحالي',
    loadMore: 'تحميل المزيد',
  },
  medicalRecords: {
    pageTitle: 'السجل الطبي',
    empty: 'لا توجد نتائج.',
    date: 'التاريخ',
    doctor: 'الطبيب',
    vendor: 'مقدم الخدمة',
    detail: 'التخصص',
    service: 'الخدمة',
    recordNumber: 'رقم السجل',
    actions: 'الإجراءات',
    view: 'عرض',
    download: 'تحميل',
    print: 'طباعة',
    close: 'إغلاق',
  },
  payments: {
    pageTitle: 'الدفع',
    back: 'رجوع',
    submit: 'إتمام الدفع',
    processing: 'جاري المعالجة...',
    success: 'تم الدفع بنجاح',
    failed: 'تعذر إتمام الدفع',
    missingReservation: 'تعذر إيجاد الحجز المطلوب',
    logoAlt: 'شعار فاي',
  },
  meeting: {
    back: 'العودة',
    endCall: 'إنهاء المكالمة',
    waiting: 'في انتظار الطبيب للانضمام',
    chat: 'المحادثة',
    mute: 'كتم الصوت',
    unmute: 'إلغاء الكتم',
    cameraOn: 'تشغيل الكاميرا',
    cameraOff: 'إيقاف الكاميرا',
  },
  appointments: {
    review: {
      invalidParams: 'الرابط غير صالح',
    },
    reviewSubmitted: {
      headerPrefix: 'موعد: #{{number}}',
      successTitle: 'تم استلام طلبك بنجاح',
      successDescription:
        'سيتم مراجعة طلبك وتعيين طبيب لك بأقرب وقت ممكن، وسيتم إشعارك عبر واتساب أو البريد الإلكتروني عند تأكيد الموعد.',
    },
    actions: {
      followup: {
        trigger: 'جدولة موعد متابعة',
        validationRequired: 'الرجاء اختيار تاريخ ووقت للموعد',
        success: 'تم جدولة موعد المتابعة بنجاح',
      },
      cancel: {
        trigger: 'إلغاء الموعد',
        checking: 'جاري التحقق...',
        success: 'تم إلغاء الموعد بنجاح.',
        refundSuffix: ' سيتم استرداد {{amount}} {{currency}}.',
        checkError: 'حدث خطأ أثناء التحقق من إمكانية الإلغاء.',
        fallback: 'لا يمكن إلغاء هذا الموعد.',
        reasons: {
          PAST_DEADLINE:
            'لا يمكن إلغاء الموعد. انتهت مهلة الإلغاء (6 ساعات قبل الموعد).',
          NO_PAYMENT: 'لا يوجد دفعة مرتبطة بهذا الموعد.',
          ALREADY_CANCELED: 'هذا الموعد ملغى بالفعل.',
          ALREADY_FINISHED: 'لا يمكن إلغاء موعد منتهي.',
          NOT_OWNER: 'ليس لديك صلاحية إلغاء هذا الموعد.',
        },
      },
      submitInfo: {
        trigger: 'تقديم المعلومات الإضافية',
        title: 'تقديم المعلومات الإضافية',
        doctorRequestedPrefix: 'المعلومات المطلوبة من الطبيب:',
        details: 'التفاصيل',
        detailsPlaceholder: 'يرجى كتابة المعلومات الإضافية المطلوبة هنا...',
        submit: 'إرسال',
        submitting: 'جاري الإرسال...',
        validation: 'يرجى إدخال التفاصيل أو إرفاق ملف واحد على الأقل',
      },
    },
    pageTitle: 'مواعيدي',
    tabs: {
      standard: 'مواعيد مع طبيب',
      secondOpinion: 'رأي طبي ثانٍ',
      homecare: 'رعاية منزلية',
      printing: 'الطباعة ثلاثية الأبعاد',
    },
    empty: {
      standard: 'لا توجد مواعيد.',
      secondOpinion: 'لا توجد طلبات رأي ثاني.',
      homecare: 'لا توجد حجوزات رعاية منزلية.',
      printing: 'لا توجد طلبات طباعة بعد.',
    },
    columns: {
      recordNumber: 'رقم الموعد',
      provider: 'اسم الطبيب',
      vendor: 'مقدم الخدمة',
      detail: 'التخصص',
      service: 'الخدمة',
      appointmentDate: 'الموعد',
      deliveryTime: 'وقت التسليم',
      createdAt: 'تاريخ الحجز',
      requestedAt: 'تاريخ الطلب',
      status: 'حالة الموعد',
    },
    detail: {
      notFound: 'لم يتم العثور على الموعد.',
      canceled: 'تم إلغاء الموعد',
      joinNotice:
        'يمكنك الانضمام إلى الموعد قبل {{minutes}} دقيقة من الوقت المحدد',
      copyLink: 'نسخ رابط الاجتماع',
      linkCopied: 'تم نسخ الرابط',
      copyFailed: 'تعذر نسخ الرابط، يرجى نسخه يدوياً',
      guestEnded: {
        title: 'تم إنهاء المكالمة',
        description: 'شكراً لمشاركتكم. يمكنكم إغلاق هذه الصفحة الآن.',
      },
      guestError: {
        invalid: 'الرابط غير صالح',
        invalidDescription:
          'هذا الرابط غير صحيح أو منتهي الصلاحية. يرجى التواصل مع الجهة التي أرسلت الرابط.',
        tooEarly: 'الموعد لم يبدأ بعد',
        tooEarlyDescription:
          'يمكنك الانضمام للموعد قبل ٣٠ دقيقة من الوقت المحدد.',
        ended: 'انتهى الموعد',
        endedDescription: 'لقد انتهى الموعد ولم يعد بالإمكان الانضمام إليه.',
        notAvailable: 'الموعد غير متاح',
        notAvailableDescription:
          'هذا الموعد غير متاح حالياً. يرجى التواصل مع الجهة التي أرسلت الرابط.',
      },
      refunded: 'تم استرداد {{amount}} {{currency}}',
      currencySar: 'ريال',
      back: 'رجوع',
      defaultTitle: 'موعد',
      card: {
        titleWithSpecialty: 'موعد مع {{specialty}}',
        statusLabel: 'الحالة:',
        priceLabel: 'السعر:',
        paid: 'مدفوع',
        appointmentNumber: 'رقم الموعد:',
        appointmentDate: 'تاريخ الموعد:',
        serviceType: 'نوع الخدمة:',
        caseDoctor: 'طبيب الحالة:',
        followupAvailable:
          'يمكن طلب مراجعة مع الطبيب خلال مدة لا تتجاوز 13 يوم 20:25 ساعة',
        attachmentsHeader: 'البيانات المرفقة',
        viewAttachments: 'عرض البيانات المرفقة',
      },
      finished: {
        closedOn: 'تم إغلاق الحالة بنجاح بتاريخ: {{date}}',
      },
      additional: {
        title: 'بيانات إضافية',
        doctorNotes: 'ملاحظات الطبيب',
        noNotes: 'لا يوجد',
      },
      patientSummary: {
        name: 'الاسم',
        age: 'العمر',
        gender: 'الجنس',
        specialty: 'التخصص المختار',
        attachments: 'ملفات مرفقة',
        noAttachments: 'لا يوجد',
      },
      patientInfo: {
        title: 'المعلومات العامة',
        name: 'الاسم:',
        membership: 'رقم العضوية:',
        phone: 'رقم الهاتف:',
        email: 'الايميل:',
        age: 'العمر:',
        gender: 'الجنس:',
        residence: 'مكان الإقامة:',
        nationalId: 'الرقم الوطني:',
        entity: 'الجهة:',
        cancelNotice: 'يمكن إلغاء الموعد لحد أقصاه بعد التقديم بـ ٢٤ ساعة.',
        editNotice: 'تعديل البيانات المرفقة قد ينتج عنه تأخير الموعد.',
        usageLimit: 'الرصيد المتاح:',
        usageLimitCount: '{{value}} استشارة',
      },
      payment: {
        title: 'تفاصيل الدفع',
        total: 'المبلغ الكلي:',
        insuranceDiscount: 'خصم التأمين:',
        finalAmount: 'المبلغ النهائي:',
      },
      diagnosisCards: {
        sectionTitle: 'نتائج الزيارات',
        visit: 'زيارة #{{number}}',
        noResults: 'لا توجد نتائج لهذه الزيارة.',
        medications: 'الأدوية',
        labTests: 'الفحوصات الطبية',
        icd10: 'التشخيص الطبي',
        downloadReport: 'تحميل التقرير الطبي',
        downloadPrescription: 'تحميل الوصفة الطبية',
        downloadLabTests: 'تحميل التحاليل الطبية',
        downloadSickLeave: 'تحميل شهادة الإجازة المرضية',
        prescriptionDetails:
          '{{strength}} {{unit}} | {{dosage}} مرة/اليوم | {{period}} | {{form}}',
      },
      attachmentsDialog: {
        title: 'البيانات المرفقة',
        selectedSpecialty: 'التخصص المختار',
        attachedFiles: 'الملفات المرفقة',
        uploadNewFile: 'تحميل ملف جديد',
        close: 'إغلاق',
        viewFile: 'عرض',
      },
      appointmentResults: {
        title: 'نتائج الموعد',
        farewell: 'مع تمنياتي بالشفاء العاجل.',
        downloadPrescription: 'تحميل الوصفة الطبية',
        downloadLabTests: 'تحميل التحاليل الطبية',
        downloadReport: 'تحميل التقرير الطبي',
        downloadSickLeave: 'تحميل شهادة الإجازة المرضية',
        medications: 'الأدوية',
        labTests: 'الفحوصات الطبية',
        icd10: 'التشخيص الطبي',
        prescriptionDetails:
          'القوة: {{strength}} {{unit}} | الجرعة: {{dosage}} مرة / اليوم | المدة: {{period}} | الشكل: {{form}}',
      },
      statuses: {
        waitingDoctorAssignment: 'قيد المراجعة وسيتم اعلامك في حال التأكيد',
        waitingDoctorConfirmation: 'تم إرسال طلبك للطبيب، وبانتظار التأكيد.',
        confirmed: 'وقت الموعد المؤكد: {{date}} - {{time}}',
        finished: 'تم الانتهاء من الموعد بتاريخ: {{date}} - {{time}}',
        canceledOn: 'تم الغاء الموعد بتاريخ: {{date}}',
        expired: 'انتهت صلاحية هذا الموعد.',
      },
      timeline: {
        header: 'الحركات',
        reservationCreated: {
          title: 'تم إنشاء موعد #{{number}}',
          message:
            'تم إنشاء حجز جديد بنجاح. سيتم مراجعة طلبك وتعيين طبيب مختص في أقرب وقت ممكن.',
        },
        reservationCanceled: {
          title: 'تم تأكيد إلغاء الحجز',
          message: 'تم إلغاء الموعد بنجاح، بناء على طلبك',
        },
        reservationFinished: {
          title: 'تم تغيير وضع الحالة لمنتهي بنجاح',
          message:
            'تم تغيير وضع الحالة لمنتهي بنجاح بعد انتهاء مدة المراجعة المسموحة',
        },
        doctorAssigned: {
          title: 'تم تحدد طبيب للحالة',
          message: 'تم تعيين الدكتور {{name}} لمتابعة حالتك.',
        },
        appointmentConfirmed: {
          title: 'تم تأكيد الموعد',
          message: 'تم تأكيد الموعد بتاريخ: {{date}} - {{time}}',
        },
        waitingDoctorConfirmation: {
          title: 'انتظار تأكيد الطبيب للموعد',
          message: 'تم إرسال طلب الموعد إلى الطبيب وفي انتظار تأكيده.',
        },
        infoSubmitted: {
          title: 'تم إرسال معلومات إضافية',
          message:
            'قام المريض بإرسال معلومات أو مرفقات إضافية للموعد. يرجى مراجعة التفاصيل المحدثة.',
        },
        moreInfoNeeded: {
          title: 'مطلوب مزيد من المعلومات',
          message:
            'يطلب الطبيب مزيدًا من المعلومات لمراجعة حالتك بشكل أفضل. يرجى تقديم المعلومات المطلوبة.',
        },
        patientJoinedCall: {
          title: 'انضم المريض للمكالمة',
          message: 'تم تسجيل انضمامك للمكالمة.',
        },
        doctorJoinedCall: {
          title: 'انضم الطبيب للمكالمة',
          message: 'انضم الطبيب للمكالمة.',
        },
        referred: {
          title: 'تمت الإحالة إلى طبيب آخر',
          message:
            'تمت إحالتك إلى طبيب آخر لمزيد من التقييم. سيتم تحديث تفاصيل الموعد قريبًا.',
        },
        markedAvailableForFollowup: {
          title: 'تم تحديد الموعد للمتابعة',
          message:
            'الحالة متاحة للمتابعة. يمكنك حجز موعد متابعة خلال الفترة المحددة.',
        },
        followupWindowExpired: {
          title: 'انتهت فترة المتابعة',
          message: 'انتهت فترة المتابعة المتاحة لهذا الموعد.',
        },
        followupTimeRejected: {
          title: 'تم رفض وقت المتابعة',
          message: 'رفض الطبيب الوقت المحدد للمتابعة. يرجى اختيار وقت آخر.',
        },
      },
    },
  },
  shell: {
    language: {
      switchTo: 'التبديل إلى',
      arabic: 'العربية',
      english: 'English',
      aria: 'تبديل اللغة',
    },
    sidebar: {
      home: 'الرئيسية',
      appointments: 'المواعيد',
      doctors: 'الأطباء',
      labResults: 'النتائج المخبرية',
      copilot: 'Copilot',
      profile: 'الملف الشخصي',
      notifications: 'الإشعارات',
      logout: 'تسجيل الخروج',
    },
  },
  auth: {
    common: {
      signin: 'تسجيل الدخول',
      signup: 'إنشاء حساب',
      signingIn: 'جاري التسجيل...',
      processing: 'جاري المعالجة...',
      continue: 'المتابعة',
      back: 'رجوع',
      phone: 'الجوال',
      email: 'البريد الإلكتروني',
      password: 'كلمة السر',
      newPassword: 'كلمة المرور الجديدة',
      confirmPassword: 'تأكيد كلمة المرور',
      emailPlaceholder: 'me@example.com',
      returnToLogin: 'العودة إلى تسجيل الدخول',
    },
    signin: {
      title: 'تسجيل الدخول',
      subtitle: 'ادخل بياناتك في الاسفل.',
      noAccount: 'ليس لديك حساب؟',
      createAccount: 'أنشىء حساب',
      b2bLogin: 'تسجيل الدخول باستخدام حساب مستشفى',
    },
    signup: {
      title: 'إنشاء حساب',
      subtitle: 'انضم الآن لقرارات صحية أكثر ثقة.',
      agreeTo: 'أوافق على',
      termsLinkLabel: 'سياسة الاستخدام والخصوصية',
      haveAccount: 'لديك حساب؟',
      submit: 'إنشاء حساب',
    },
    verifyPhone: {
      title: 'تأكيد رقم الجوال',
      subtitle: 'الرجاء إدخال رمز التأكيد المرسل لرقم الجوال',
      didntReceive: 'لم يصلك الرمز؟',
      verifying: 'جاري التحقق...',
      submit: 'تأكيد رقم الجوال',
      resend: 'إعادة الإرسال',
      attemptCount: '(المحاولة {{value}})',
      expired: 'انتهت الصلاحية',
    },
    b2bLogin: {
      title: 'تسجيل الدخول',
      subtitle: 'ادخل بياناتك في الاسفل.',
      forgotPassword: 'نسيت كلمة المرور؟',
    },
    b2bForgotPassword: {
      title: 'نسيت كلمة المرور؟',
      subtitle:
        'ادخل البريد الاكتروني الخاص بك في الاسفل لتصلك رسالة اعادة التفعيل.',
      submit: 'استرجاع',
      success: 'تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني',
      haveAccount: 'لديك حساب؟',
    },
    b2bResetPassword: {
      title: 'إعادة تعيين كلمة المرور',
      subtitle: 'أدخل كلمة المرور الجديدة لحساب',
      passwordHint: 'يجب أن تكون على الأقل من ٨ خانات',
      submit: 'تغيير كلمة المرور',
      success:
        'تم تغيير كلمة المرور بنجاح، جاري تحويلك إلى صفحة تسجيل الدخول...',
      invalidLinkFallback: 'رمز التحقق غير صالح أو منتهي الصلاحية',
      backToForgot: 'العودة إلى استعادة كلمة المرور',
      errors: {
        linkNotFound: 'لم يتم العثور على رابط إعادة تعيين كلمة المرور',
        codeMissing: 'لم يتم العثور على رمز التحقق في الرابط',
        invalidOrExpired: 'رمز التحقق غير صالح أو منتهي الصلاحية',
        genericReset: 'حدث خطأ أثناء تغيير كلمة المرور',
        mismatch: 'كلمات المرور غير متطابقة',
      },
    },
    changePassword: {
      title: 'تغيير كلمة المرور',
      subtitle: 'لحماية حسابك، يجب تعيين كلمة مرور جديدة قبل المتابعة.',
      currentPassword: 'كلمة المرور الحالية',
      newPassword: 'كلمة المرور الجديدة',
      confirmPassword: 'تأكيد كلمة المرور',
      hint: 'يجب أن تكون على الأقل ٨ خانات',
      submit: 'حفظ',
      reSignInRequired: 'تم تحديث كلمة المرور. يرجى تسجيل الدخول مرة أخرى.',
      validation: {
        currentRequired: 'كلمة المرور الحالية مطلوبة',
        passwordRequired: 'كلمة المرور مطلوبة ويجب أن تحتوي على الأقل 8 أحرف',
        confirmRequired: 'تأكيد كلمة المرور مطلوب',
        mismatch: 'كلمات المرور غير متطابقة',
        wrongCurrent: 'كلمة المرور الحالية غير صحيحة',
        weakPassword: 'كلمة المرور ضعيفة جداً',
        genericError: 'حدث خطأ أثناء تغيير كلمة المرور',
        syncError: 'تعذر إكمال التحديث. يرجى إعادة المحاولة.',
      },
    },
    completeProfile: {
      title: 'انشاء حساب',
      subtitle: 'الرجاء تعبئة بيانات المستخدم في الاسفل',
      firstName: 'الاسم الأول',
      parentName: 'اسم الأب (اختياري)',
      lastName: 'الاسم الأخير',
      nationalId: 'الرقم الوطني / الاقامة (اختياري)',
      termsAcknowledgement:
        'أقرّ بصحة المعلومات المقدمة وأتحمل المسؤولية عن أي بيانات غير دقيقة.',
    },
    logout: {
      title: 'تسجيل الخروج',
      confirm: 'هل أنت متأكد من أنك تريد تسجيل الخروج من حسابك؟',
      submit: 'تسجيل الخروج',
      cancel: 'إلغاء',
    },
  },
  shared: {
    firebase: {
      invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
      tooManyAttempts:
        'تم حظر تسجيل الدخول بسبب محاولات متكررة، يرجى المحاولة لاحقاً',
      accountDisabled: 'تم تعطيل الحساب، يرجى التواصل مع الدعم الفني',
      networkFailed: 'فشل الاتصال بالشبكة، يرجى التحقق من اتصالك بالإنترنت',
      loginNotSupported:
        'تسجيل الدخول بالبريد الإلكتروني وكلمة المرور غير مدعوم حالياً',
      invalidEmail: 'البريد الإلكتروني غير صحيح، يرجى المحاولة مرة أخرى',
      invalidPassword: 'كلمة المرور غير صحيحة، يرجى المحاولة مرة أخرى',
      loginError: 'حدث خطأ أثناء تسجيل الدخول',
      logoutError: 'حدث خطأ أثناء تسجيل الخروج',
      invalidPhone: 'رقم الجوال غير صحيح، يرجى المحاولة مرة أخرى',
      emailInUse: 'هذا البريد الإلكتروني مستخدم بالفعل',
      phoneInUse: 'رقم الجوال هذا مرتبط بحساب آخر',
      accountExistsDifferentMethod:
        'يوجد حساب بالفعل بنفس البريد الإلكتروني ولكن باستخدام طريقة تسجيل دخول مختلفة، يرجى التواصل مع الدعم الفني',
      recaptchaError: 'خطأ في التحقق، يرجى المحاولة مرة أخرى',
      signupError: 'حدث خطأ أثناء تسجيل الدخول',
      confirmationNotFound:
        'لم يتم العثور على عملية تحقق نشطة، يرجى إعادة إرسال الرمز',
      invalidCode: 'رمز التحقق غير صحيح، يرجى المحاولة مرة أخرى',
      phoneVerificationError: 'حدث خطأ أثناء التحقق من رقم الجوال',
      noActiveVerification:
        'لم يتم العثور على عملية تحقق نشطة، يرجى المحاولة مرة أخرى',
      emailNotRegistered: 'البريد الإلكتروني غير مسجل',
      resetEmailError: 'حدث خطأ أثناء إرسال رابط إعادة التعيين',
      resetCodeError: 'حدث خطأ أثناء إرسال رمز التحقق',
    },
    api: {
      notB2bPatient: 'هذه الخدمة متاحة فقط لمرضى الشركات',
      b2bPatientProfileNotFound:
        'لم يتم العثور على ملف المريض، يرجى التواصل مع الإدارة',
      b2bUsageLimitExhausted:
        'لقد استنفدت الرصيد المتاح، يرجى التواصل مع الإدارة',
      filesNotFound: 'بعض الملفات المرفقة غير صالحة',
      noDoctorsAvailable: 'لا يوجد أطباء متاحين في الوقت المحدد',
      doctorNotAvailable: 'الطبيب غير متاح في الوقت المحدد',
      recordNotFound: 'البيانات المطلوبة غير موجودة',
      validationFailed: 'البيانات المدخلة غير صحيحة',
      forbidden: 'غير مصرح لك بالوصول',
      uniqueConstraint: 'القيمة المدخلة في حقل {{fields}} مستخدمة بالفعل',
      validationGeneric: 'خطأ في التحقق من صحة البيانات',
      formValidation: 'خطأ في التحقق من صحة النموذج',
      genericUnexpected: 'حدث خطأ غير متوقع',
      retryLater: 'حدث خطأ غير متوقع، يرجى المحاولة لاحقًا',
      unauthorized: 'غير مصرح لك بهذا الإجراء',
      featureDisabled: 'هذه الخدمة غير متاحة حالياً',
    },
    fields: {
      phoneNumber: 'رقم الهاتف',
      email: 'البريد الإلكتروني',
      fallback: 'الحقل',
    },
    validation: {
      phoneRequired: 'رقم الجوال مطلوب',
      phoneRequiredAlt: 'مطلوب رقم الجوال',
      termsRequired: 'يجب الموافقة على الشروط والأحكام',
      otpLength: 'يجب إدخال رمز التحقق المكون من 6 أرقام',
      nameRequired: 'الاسم مطلوب',
      nameCharactersOnly:
        'الاسم يجب أن يحتوي على أحرف فقط بدون أرقام أو رموز خاصة',
      emailInvalid: 'البريد الإلكتروني غير صحيح',
      emailRequired: 'البريد الإلكتروني مطلوب',
      passwordRequired: 'كلمة المرور مطلوبة',
      passwordMin: 'كلمة المرور مطلوبة ويجب أن تحتوي على الأقل 8 أحرف',
      confirmPasswordRequired: 'تأكيد كلمة المرور مطلوب',
      birthDateRequired: 'تاريخ الميلاد مطلوب',
      genderRequired: 'الجنس مطلوب',
      termsAcknowledgeRequired: 'يجب تأكيد صحة المعلومات',
      fileMimeNotSupported:
        'صيغة ملف غير مدعومة. الصيغ المسموح بها: PDF, PNG, JPG, ZIP',
      fileSizeExceeded:
        'حجم الملف يتجاوز الحد المسموح (١٠ ميجابايت، ٢ جيجابايت لملفات ZIP)',
    },
  },
  printing: {
    title: 'طلبات الطباعة ثلاثية الأبعاد',
    subtitle:
      'أرسل ملف الفحص أو النموذج وسيقوم فريقنا المتخصص بإنتاجه بالتعاون مع مستشفانا الشريك.',
    submitted: 'تم إرسال طلب الطباعة بنجاح',
    submittedWithRemaining: 'تم إرسال الطلب. الرصيد المتبقي: {{remaining}}.',
    topUpHint: 'يرجى التواصل مع المسؤول لتجديد الرصيد.',
    quotaRemaining: 'الرصيد المتبقي',
    form: {
      description: 'وصف الطلب',
      descriptionPlaceholder:
        'مثال: يرجى طباعة نموذج الفك السفلي للتخطيط الجراحي...',
      files: 'الملفات المرفقة (ZIP)',
      submit: 'إرسال الطلب',
      submitting: 'جارٍ الإرسال...',
    },
    cards: {
      prefix: 'طلب طباعة',
      doctorName: 'الطبيب المعيَّن',
    },
    detail: {
      linkReady: 'رابط التنزيل جاهز',
      downloadUrl: 'رابط التنزيل',
      downloadPassword: 'كلمة المرور',
      openLink: 'فتح الرابط في علامة تبويب جديدة',
      requestDetails: 'تفاصيل الطلب',
      description: 'الوصف',
      submittedOn: 'تاريخ الإرسال',
      files: 'الملفات',
      downloadFile: 'تحميل',
    },
    validation: {
      descriptionRequired: 'يرجى وصف ما تود طباعته',
      filesRequired: 'يرجى إرفاق ملف واحد على الأقل (ZIP)',
    },
  },
};

export default ar;
